import { ConditionalRuleValueAll } from 'dashboard/lib/workflows/conditional';

export type JsonLogicField = { var: string };
export type JsonLogicValue = string | string[] | boolean | number | null;

export enum RuleValueTypes {
  Value = 'Value',
  Field = 'Field',
  Rule = 'Rule',
  Variable = 'Variable',
}

export type RuleValueConfigField = {
  type: RuleValueTypes.Field;
  value: JsonLogicField;
  paths: string[];
};
export type RuleValueConfigValue = {
  type: RuleValueTypes.Value;
  value: JsonLogicValue;
  paths: [];
};
export type RuleValueConfigFieldMulti = {
  type: RuleValueTypes.Field;
  value: JsonLogicField[];
  paths: string[];
};

export const isJsonLogicField = (value: ConditionalRuleValueAll): value is JsonLogicField => {
  return !!value && typeof value === 'object' && 'var' in value;
};
